export const ALERTS_HEADING_HEIGHT = 56;
export const HEADING_HEIGHT = 196;

export const HEADING_MAX_HEIGHT = 298 + ALERTS_HEADING_HEIGHT;
